import clsx from 'clsx';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

import GrammarViewer from '../../../../../../common/grammarViewer/GrammarViewer';

function MultipleChoiceQuestionKeypad({
  questions,
  // answerView,
  answers,
  onSubmit,
  answersQuestion,
  type,
  wrongAnswer,
  handleChange,
  handleQestion,
  isShowAnswer
}) {
  const [isClose, setIsClose] = useState(false);

  useEffect(() => {
    handleQestion();
  }, [answersQuestion]);

  const handleClose = useCallback(() => {
    setIsClose(!isClose)
  }, [isClose])
  
  return (
    <div 
      className={
        clsx(
          "multiple-choice-wrap",
          isClose && 'close'
        )
      }
    >
      <button 
        type="button" 
        className="btn-answer-close"
        onClick={handleClose}
      >
        <span>닫기</span>
      </button>
      <div className="answer-box">
        <ul className="list">
          {
            (questions && questions.length > 0) && (
              questions.map((item, index) => (
                <li key={index}>
                  <input 
                    type="checkbox" 
                    name="multi_answer" 
                    id={`answer_${index}`} 
                    value={item}
                    checked={
                      type === 'learning'
                        ? _.findIndex(answers, (v) => v === item) !== -1
                        :
                        (wrongAnswer && wrongAnswer.indexOf(item) > -1 && !isShowAnswer) 
                          || (isShowAnswer && answers.indexOf(item) > -1)
                            ? true 
                            : false
                    }
                    onChange={handleChange}
                  />
                  <label 
                    htmlFor={`answer_${index}`} 
                    className={
                      clsx(
                        "list-item",
                        (wrongAnswer && (wrongAnswer.indexOf(item) > -1 ? true : false) && !isShowAnswer) && 'incorrect'
                      )
                    }
                  >
                    <span>선택</span>
                  </label>
                  <div className="math-answer">
                    {
                      <GrammarViewer>
                        {item}
                      </GrammarViewer>               
                    }
                  </div>
                </li>
              ))
            )
          }
        </ul>
      </div>
      {
        type === 'learning' && (
          <div className="btn-area">
            <button 
              className="btn btn-green" 
              type="button"
              onClick={onSubmit}
            >
              다음문제
            </button>
          </div>
        )
      }
    </div>
  );
}

export default MultipleChoiceQuestionKeypad;